(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jayda-featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* ---------------- Carousel ---------------- */
    function initCarousel(section) {
      var track = section.querySelector('.jfc-track');
      if (!track) return;
      var products = section.querySelector('.jfc-products');
      var prev = section.querySelector('.jfc-prev');
      var next = section.querySelector('.jfc-next');

      function rtl() { return getComputedStyle(track).direction === 'rtl'; }
      function maxScroll() { return track.scrollWidth - track.clientWidth; }
      function pos() { return Math.abs(track.scrollLeft); }

      function update() {
        var max = maxScroll();
        var scrollable = max > 2;
        section.classList.toggle('jfc-no-scroll', !scrollable);
        track.classList.toggle('jfc-draggable', scrollable);
        if (scrollable) { track.setAttribute('tabindex', '0'); } else { track.removeAttribute('tabindex'); }

        if (prev) prev.disabled = !scrollable || pos() <= 2;
        if (next) next.disabled = !scrollable || pos() >= max - 2;
        if (prev && next) {
          if (document.activeElement === next && next.disabled && !prev.disabled) prev.focus();
          if (document.activeElement === prev && prev.disabled && !next.disabled) next.focus();
        }

        var media = track.querySelector('.jfc-media');
        if (media && products) {
          products.style.setProperty('--jfc-arrow-top', (media.offsetTop + media.offsetHeight / 2) + 'px');
        }
      }

      function step() {
        var item = track.querySelector('.jfc-item');
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var w = item.getBoundingClientRect().width + gap;
        var n = Math.max(1, Math.floor((track.clientWidth + gap) / w));
        return n * w;
      }

      function go(dir) {
        track.scrollBy({ left: dir * step() * (rtl() ? -1 : 1), behavior: reduce ? 'auto' : 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      /* Mouse drag (touch uses native swipe) */
      var drag = { active: false, moved: false, startX: 0, startLeft: 0, id: null };

      function snapNearest() {
        var items = track.querySelectorAll('.jfc-item');
        var cs = getComputedStyle(track);
        var tr = track.getBoundingClientRect();
        var isRtl = rtl();
        var pad = parseFloat(isRtl ? cs.scrollPaddingRight : cs.scrollPaddingLeft) || 0;
        var best = 0;
        var bestAbs = Infinity;
        for (var i = 0; i < items.length; i++) {
          var r = items[i].getBoundingClientRect();
          var d = isRtl ? (r.right - (tr.right - pad)) : (r.left - (tr.left + pad));
          if (Math.abs(d) < bestAbs) { bestAbs = Math.abs(d); best = d; }
        }
        track.scrollBy({ left: best, behavior: reduce ? 'auto' : 'smooth' });
        setTimeout(function () { track.classList.remove('jfc-dragging'); }, reduce ? 0 : 450);
      }

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (maxScroll() <= 2) return;
        if (e.target.closest('button, input, select, textarea')) return;
        drag.active = true;
        drag.moved = false;
        drag.startX = e.clientX;
        drag.startLeft = track.scrollLeft;
        drag.id = e.pointerId;
      });

      track.addEventListener('pointermove', function (e) {
        if (!drag.active) return;
        var dx = e.clientX - drag.startX;
        if (!drag.moved && Math.abs(dx) > 5) {
          drag.moved = true;
          track.classList.add('jfc-dragging');
          try { track.setPointerCapture(drag.id); } catch (err) {}
        }
        if (drag.moved) {
          e.preventDefault();
          track.scrollLeft = drag.startLeft - dx;
        }
      });

      function endDrag() {
        if (!drag.active) return;
        drag.active = false;
        if (drag.moved) snapNearest();
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('lostpointercapture', endDrag);

      track.addEventListener('click', function (e) {
        if (drag.moved) {
          e.preventDefault();
          e.stopPropagation();
          drag.moved = false;
        }
      }, true);

      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; update(); });
      }, { passive: true });

      if ('ResizeObserver' in window) { new ResizeObserver(update).observe(track); }
      else { window.addEventListener('resize', update); }

      update();
    }

    /* ---------------- Add to cart ---------------- */
    function initForms(section) {
      var mode = section.getAttribute('data-jfc-after-add');
      if (mode !== 'drawer' && mode !== 'stay') return;
      if (!window.fetch || !window.FormData) return;

      var labelAdding = section.getAttribute('data-label-adding') || 'Adding…';
      var labelAdded = section.getAttribute('data-label-added') || 'Added to cart';
      var live = section.querySelector('[data-jfc-live]');
      var forms = section.querySelectorAll('form[data-jfc-form]');

      for (var i = 0; i < forms.length; i++) {
        forms[i].addEventListener('submit', onSubmit);
      }

      function onSubmit(e) {
        e.preventDefault();
        var form = e.currentTarget;
        var btn = form.querySelector('[type="submit"]');
        var label = btn ? btn.querySelector('.jfc-btn-label') : null;
        var msg = form.parentNode.querySelector('.jfc-form-msg');
        if (!btn || btn.getAttribute('aria-busy') === 'true') return;

        var original = label ? label.textContent : '';
        btn.setAttribute('aria-busy', 'true');
        if (label) label.textContent = labelAdding;
        if (msg) { msg.hidden = true; msg.textContent = ''; }

        var cartEl = mode === 'drawer'
          ? (document.querySelector('cart-drawer') || document.querySelector('cart-notification'))
          : null;

        var sections = [];
        if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
          sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
        } else if (document.getElementById('cart-icon-bubble')) {
          sections = ['cart-icon-bubble'];
        }

        var body = new FormData(form);
        if (sections.length) {
          body.append('sections', sections.join(','));
          body.append('sections_url', window.location.pathname);
        }

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok || res.data.status) {
              throw new Error(res.data.description || res.data.message || 'Something went wrong.');
            }
            var data = res.data;

            if (mode === 'drawer') {
              if (cartEl && typeof cartEl.renderContents === 'function') {
                cartEl.classList.remove('is-empty');
                if (typeof cartEl.setActiveElement === 'function') cartEl.setActiveElement(btn);
                cartEl.renderContents(data);
                reset();
              } else {
                window.location.href = root + 'cart';
              }
              return;
            }

            /* stay on page */
            var bubbleHtml = data.sections && data.sections['cart-icon-bubble'];
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && bubbleHtml) {
              var doc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
              var srcEl = doc.querySelector('.shopify-section');
              bubble.innerHTML = srcEl ? srcEl.innerHTML : bubbleHtml;
            }
            document.dispatchEvent(new CustomEvent('jfc:cart:added', { detail: data }));

            if (label) label.textContent = labelAdded;
            if (live) live.textContent = labelAdded + ': ' + (btn.getAttribute('data-product-title') || '');
            setTimeout(reset, 2000);
          })
          .catch(function (err) {
            reset();
            if (msg) { msg.textContent = err.message; msg.hidden = false; }
          });

        function reset() {
          btn.removeAttribute('aria-busy');
          if (label) label.textContent = original;
        }
      }
    }

    /* ---------------- Init ---------------- */
    function initSection(section) {
      if (!section || section.getAttribute('data-jfc-ready')) return;
      section.setAttribute('data-jfc-ready', '1');
      initForms(section);
      if (section.hasAttribute('data-jfc-carousel')) initCarousel(section);
    }

    function initAll(scope) {
      var sections = (scope || document).querySelectorAll('.jayda-featured-collection');
      for (var i = 0; i < sections.length; i++) initSection(sections[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
